module.exports = {
	"optional": "Optional",
	"required": "Required field",
	"specialCharacters": "Should not contain special characters: !@#$%^&*()+=><?",
	"specialCharactersShort": "No special characters",
	"specialCharactersAddress": "Should not contain special characters: !@$%^&*()+=><?",
	"poBox": "Item may not ship to PO Box",
	"globalZipCode": "This field may only contain no more than 9 letters, numbers, spaces, and hyphens",
	"usZipCode": "This field may only contain numbers, spaces, and hyphens",
	"usZipCodeShort": "Please enter a valid 5-digit U.S. ZIP code",
	"usZipCodeShipping": "Please enter a valid U.S. ZIP code"
};


//////////////////
// WEBPACK FOOTER
// ./~/dibs-address-validator/messages.json
// module id = 660
// module chunks = 4 7 13 14 20